import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpEditProjectEvaluationScales, HttpEditProjectScalesOptions} from '@/features/projects/http/projects.http'
import {EvaluationScaleExtended} from '@/features/projects/types'

export const useEditProjectEvaluationScales = ({
    urlParams,
    options
}: {
    urlParams: HttpEditProjectScalesOptions['urlParams']
    options?: UseMutationOptions<EvaluationScaleExtended[], unknown, EvaluationScaleExtended[]>
}) => useMutation({mutationFn: payload => httpEditProjectEvaluationScales({urlParams, payload}), ...options})
